export default "__VITE_ASSET__OFPszRAT__"